/**
 * OnboardShop — shared constants & helpers.
 * Extracted from `pages/admin/OnboardShop.js`.
 */
import React from 'react';

export const PRESET_COLOURS = ['#1f2a1e', '#b03a2e', '#4f46ff', '#c8a35a', '#111210'];
export const SUBDOMAIN_RE = /^[a-z0-9](?:[a-z0-9-]{0,28}[a-z0-9])?$/;
// JS Date.getDay() convention: 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat.
// Every reader of `barber_hours.weekday` uses this convention; the wizard
// must match. Historical bug: this array was ['Mon',...,'Sun'] which wrote
// weekday=0 for Monday and broke My-schedule/Diary/Next-available lookups
// for any barber onboarded through the master-admin wizard.
export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const genPw = () => {
  const set = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let out = '';
  for (let i = 0; i < 12; i++) out += set[Math.floor(Math.random() * set.length)];
  return out;
};

export const emptyBarber = () => ({
  name: '', role: '', bio: '',
  giveLogin: false, email: '', password: genPw(),
  hours: WEEKDAYS.map((_, i) => ({
    weekday: i, start_time: '09:00', end_time: '18:00',
    is_open: i !== 0,   // closed Sunday (weekday=0) by default
  })),
});

export const emptyService = () => ({ name: '', price: '', duration_min: 30 });

export const STEPS_FULL = [
  { key: 'shop',     label: 'Shop' },
  { key: 'owner',    label: 'Owner' },
  { key: 'barbers',  label: 'Barbers' },
  { key: 'services', label: 'Services' },
  { key: 'hours',    label: 'Hours' },
  { key: 'stripe',   label: 'Stripe (skip OK)' },
  { key: 'review',   label: 'Review & finish' },
];

export const STEPS_ASSISTED = [
  { key: 'shop',   label: 'Shop' },
  { key: 'owner',  label: 'Owner (email handover)' },
  { key: 'review', label: 'Send' },
];

export const SubStatus = ({ status }) => {
  if (status === 'idle') return null;
  if (status === 'checking') return <small style={{ color: 'var(--text-mute)' }}>Checking…</small>;
  if (status === 'invalid') return <small style={{ color: 'var(--red)' }}>Must be 2–30 chars, lowercase letters, numbers or dashes.</small>;
  if (status === 'taken') return <small style={{ color: 'var(--red)' }}>Already taken.</small>;
  if (status === 'ok') return <small style={{ color: 'var(--green)' }}>Available</small>;
  return null;
};
